/* eslint-disable no-unused-vars */

const DEFAULT_FILTERS = {
	facility: [],
	dateFrom: null,
	dateTo: null,
};

export const GLOBAL_DASHBOARD_FILTERS = {
	namespaced: true,
	state: {
		selectedfilters: { ...DEFAULT_FILTERS },
		loading: false,
	},
	getters: {
		GET_FILTERS(state) {
			return state.selectedfilters;
		},
		GET_LOADING(state) {
			return state.loading;
		},
		GET_DEFAULT_FILTERS() {
			return { ...DEFAULT_FILTERS };
		},
	},
	mutations: {
		SET_FILTERS(state, value) {
			state.selectedfilters = value;
		},
		RESET_FILTERS(state) {
			state.selectedfilters = { ...DEFAULT_FILTERS };
		},
		SET_LOADING(state, value) {
			state.loading = value;
		},
	},
	actions: {
		RESET({ commit }) {
			commit('RESET_FILTERS');
		},
	},
};
